<template>
  <div class="demand_box">
    <div class="owner_title">修改写手信息</div>
    <div class="owner_box">
      <el-form ref="editInfoForm" :rules="rules" :model="editInfoForm" label-width="130px">
        <el-form-item label="写手昵称" prop="nickname">
          <el-input class="inpt_size" v-model="editInfoForm.nickname"></el-input>
        </el-form-item>
        <el-form-item label="写手姓名" prop="name">
          <el-input class="inpt_size" v-model="editInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="写手QQ" prop="qq_account">
          <el-input class="inpt_size" v-model="editInfoForm.qq_account"></el-input>
        </el-form-item>
        <el-form-item label="写手支付宝" prop="alipay_account">
          <el-input class="inpt_size" v-model="editInfoForm.alipay_account"></el-input>
        </el-form-item>
        <el-form-item label="写手电话号码" prop="mobile">
          <el-input class="inpt_size" v-model="editInfoForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="初始压稿金额" prop="initial_press_release">
          <el-input class="inpt_size" v-model="editInfoForm.initial_press_release"></el-input>
        </el-form-item>
        <!-- <el-form-item label="日周结" prop="settlement_type">
          <el-radio-group v-model="editInfoForm.settlement_type">
            <el-radio :label="1">日结</el-radio>
            <el-radio :label="2">周结</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="添加标签" prop="connectionlabel_ids">
          <!-- <el-checkbox v-for="(item, index) in editInfoForm.connectionlabel_ids" :key="item.id" :label="item.name"
            @change="selectLabel(item)">{{ item.name }}</el-checkbox> -->
          <el-checkbox v-for="(item, index) in labeList" :key="item.id" :label="item.name" v-model="item.status"
            :true-label="1" :false-label="0" @change="selectLabel(item, index)">{{ item.name }}</el-checkbox>
          <!-- <el-checkbox-group v-model="editInfoForm.connectionlabel_ids" @change="selectLabel">
            <el-checkbox v-for="item in labeList" :key="item.id" :label="item.name">{{ item.name }}
            </el-checkbox>
          </el-checkbox-group> -->
        </el-form-item>
        <el-form-item label="批注">
          <el-input class="inpt_size" v-model="editInfoForm.connectionremark"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="edit_box">
            <el-button class="info_btn" type="primary" round @click="onSubmiOwnerDwmand">确认修改</el-button>
            <el-button class="info_btn" type="info" plain round @click="goBack">取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { edit_writer, label_tabulation } from "@/utils/writer";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      user_name: "", //用户名称
      editdata: "", //参数对象
      editInfoForm: {
        departmentuser_id: "", //所属金主部id
        nickname: "", //写手昵称
        name: "", //写手姓名
        qq_account: "", //写手qq
        alipay_account: "", //写手支付宝
        mobile: "", //写手电话号码
        settlement_type: "1", //日周结
        initial_press_release: "", //初始压稿金额
        connectionlabel_ids: [], //标签
        connectionremark: "", //批注
        writer_id: "", //写手id
        writer_expand_id: "", //写手扩展id
        filterData: "" //筛选数据
      },
      labeList: [], //标签的数据
      selectLabelList: [], //选中标签的数据
      rules: {
        nickname: {
          required: true,
          trigger: "blur",
          message: "写手昵称不能为空"
        },
        initial_press_release: {
          required: true,
          trigger: "blur",
          message: "初始压稿金额不能为空"
        },
        name: { required: true, trigger: "blur", message: "写手姓名不能为空" },
        qq_account: [
          {
            required: true,
            trigger: "blur",
            message: "写手QQ不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "QQ格式不正确" }
        ],
        alipay_account: [
          {
            required: true,
            trigger: "blur",
            message: "写手支付宝不能为空"
          },
          // { pattern: /^[0-9]*$/, trigger: "blur", message: "支付宝格式不正确" }
        ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            message: "写手电话号码不能为空"
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
              if (!passwordreg.test(value)) {
                callback(new Error("手机格式不正确!"));
              } else {
                callback();
              }
            }
          }
        ],
        settlement_type: {
          required: true,
          trigger: "blur",
          message: "日周结不能为空"
        }
      }
    };
  },
  created() {
    this.editdata = JSON.parse(this.$route.query.data);
    this.filterData = JSON.parse(this.$route.query.filter);
    this.user_name = JSON.parse(localStorage.getItem("userInfo")).nickname;
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getData();
    this.getWriterLabel();
  },
  methods: {
    // 获取数据
    getData() {
      var that = this;
      that.editInfoForm.departmentuser_id = this.ownerId;
      that.editInfoForm.writer_id = this.editdata.id;
      that.editInfoForm.writer_expand_id = this.editdata.writer_expand_id;
      that.editInfoForm.name = this.editdata.name;
      that.editInfoForm.nickname = this.editdata.nickname;
      that.editInfoForm.qq_account = this.editdata.qq_account;
      that.editInfoForm.alipay_account = this.editdata.alipay_account;
      that.editInfoForm.mobile = this.editdata.mobile;
      that.editInfoForm.settlement_type = this.editdata.settlement_type;
      that.editInfoForm.connectionremark = this.editdata.connectionremark_text;
      that.editInfoForm.initial_press_release = this.editdata.initial_press_release;
      that.editInfoForm.connectionlabel_ids = this.editdata.connectionlabel_ids;
      that.selectLabelList = this.editdata.connectionlabel_ids.split(',');
      if (this.editdata.connectionlabel_ids) {
        var str = this.editdata.connectionlabel_ids;
        var select_arr = str.split(",");
        that.labeList = select_arr.map(Number);
      }
    },

    // 表单提交
    onSubmiOwnerDwmand() {
      var that = this;

      that.$refs.editInfoForm.validate(valid => {
        if (valid == true) {
          that.editInfoForm.departmentuser_id = that.ownerId;
          var arr = that.selectLabelList;
          var str = arr.join(",");
          that.editInfoForm.connectionlabel_ids = str;

          let obj = {
            ...that.editInfoForm
          };
          //修改金主信息
          edit_writer(obj).then(res => {
            if (res.data.code == 1) {
              that.$message.success(res.data.msg);
              // var time =
              //   this.filterData.createtime[0] +
              //   " - " +
              //   this.filterData.createtime[1];
              // this.filterData.createtime = time;
              this.$route.params.filter = this.filterData;
              // this.$router.back();
              this.$router.push({ path: "/myWriter" });
              // that.$router.push("/myWriter");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // 获取写手标签
    getWriterLabel() {
      var that = this;
      label_tabulation().then(res => {
        if (res.data.code == 1) {
          let _list = res.data.data
          let ids = that.editInfoForm.connectionlabel_ids.split(',')
          let indexs = []
          _list.forEach((item, index) => {
            for (let i = 0; i < ids.length; i++) {
              if (ids[i] == item.id) {
                _list[index].status = true
                indexs.push(index)
              } else {
                _list[index].status = false
              }
            }
          })
          for (let j = 0; j < indexs.length; j++) {
            let ind = indexs[j]
            _list[ind].status = true
          }
          that.labeList = _list;
          that.$forceUpdate()
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 选择标签
    selectLabel(val, lindex) {
      var that = this;
      let _list = that.selectLabelList
      let _isnew = true
      _list.forEach((item, index) => {
        if (item == val.id) {
          that.selectLabelList.splice(index, 1)
          _isnew = false
        }
      })
      if (_isnew == true) {
        that.selectLabelList.push(val.id);
        that.labeList[lindex].status = true
      } else {
        that.labeList[lindex].status = false
      }
      that.$forceUpdate()
    },
    //   取消返回首页
    goBack() {
      var that = this;
      this.$route.params.filter = this.filterData;
      this.$route.params.edit_id = 1;
      // this.$router.back();
      this.$router.push({ path: "/myWriter" });
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}

.demand_box {
  background-color: #ffffff;
  height: 100%;
}

.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.username {
  font-size: 17px;
  font-weight: 600;
}

.owner_box {
  padding: 45px 30px;
}

@media screen and (max-width: 750px) and (min-width: 375px) {
  .owner_box {
    padding: 10px;
  }

  .edit_box {
    display: flex;
    flex-direction: row;
  }

  .info_btn {
    width: 100px !important;
    height: 35px;
  }
}

.owner_box .el-form-item__label {
  width: 135px !important;
}

.el-main {
  padding: 0;
}

.inpt_size {
  width: 200px;
}

.upload_size {
  width: 230px;
}

.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}

.info_btn {
  width: 200px;
  height: 35px;
}

.task_upload_btn {
  background: #f4f8fc;
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterEdit.vue